import {ReactNode} from 'react';
import * as css from './MetricCard.css';
import {SubMetrics, TSubMetric} from '../SubMetrics/SubMetrics';

type TMetricCard = {
    area: string,
    title: string,
    icon: ReactNode,
    value: ReactNode,
    badge?: ReactNode,
    footer?: ReactNode,
    subMetrics?: TSubMetric[],
    alignEnd?: boolean,
    dataCy: string
};
export const MetricCard = ({area, title, icon, value, badge, footer, subMetrics, alignEnd, dataCy}: TMetricCard) => {
    const valueBlock = (
        <css.valueBlock>
            <css.value>{value}</css.value>
            {footer && <css.footer>{footer}</css.footer>}
        </css.valueBlock>
    );
    return (
        <css.card area={area} data-cy={dataCy}>
            <css.cardHeader>
                <css.titleGroup>
                    <css.cardTitle>{title}</css.cardTitle>
                    <css.iconBox>{icon}</css.iconBox>
                </css.titleGroup>
                {badge}
            </css.cardHeader>
            {subMetrics
                ? <css.splitRow alignEnd={alignEnd}>{valueBlock}<SubMetrics items={subMetrics}/></css.splitRow>
                : valueBlock}
        </css.card>
    );
};
